export default __webpack_public_path__ + "static/media/element_89.07fbc005.jpg";